import * as React from 'react';
import { ICON_HEIGHT } from '../common/constants';

const SvgComponent = (props: any) => (
  <svg className="icon" height={ICON_HEIGHT} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path
      fill="currentColor"
      d="M32 256C32 132.2 132.3 32 255.8 32c11.36 0 29.7 1.668 40.9 3.746 9.616 1.777 11.75 14.63 3.279 19.44C245 86.5 211.2 144.6 211.2 207.8c0 109.7 99.71 193 208.3 172.3 9.561-1.805 16.28 9.324 10.11 16.95C387.9 448.6 324.8 480 255.8 480 132.1 480 32 379.6 32 256z"
    />
  </svg>
);

export default SvgComponent;

export const IconNightOutline = (props: any) => (
  <svg className="icon" height={ICON_HEIGHT} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}>
    <path
      fill="currentColor"
      d="M421.6 379.9c-.664 0-1.35.063-2.049.195a177.696 177.696 0 0 1-33.32 3.17c-94.81 0-174.1-77.14-174.1-175.5 0-63.19 33.79-121.3 88.73-152.6 8.467-4.812 6.339-17.66-3.279-19.44-11.2-2.078-29.53-3.746-40.9-3.746C132.3 31.1 32 132.2 32 256c0 123.6 100.1 224 223.8 224 69.04 0 132.1-31.45 173.8-82.93 5.7-7.97-.5-17.17-8-17.17zM255.8 432C158.9 432 80 353 80 256c0-76.32 48.77-141.4 116.7-165.8-21.5 34.8-33.5 75.4-33.5 117.6 0 99.44 65.13 183.9 154.9 212.8-19.6 7.5-40.7 11.4-62.3 11.4z"
    />
  </svg>
);
